import pluralize from "pluralize"
import PropTypes from "prop-types"
import React from "react"
import { useQuery } from "react-query"

import ReloadableWidget from "src/components/ReloadableWidget"
import TrackingLink from "src/components/TrackingLink"

import { queryMessages } from "src/api/Dashboard"

import DashboardTooltip from "./DashboardTooltip"

const refreshRate = 300 * 1000 // 5 minutes

const renderData = (count) => {
  if (count > 0) {
    return (
      <div className="flex flex-col">
        <div className="mb-2 flex">
          <i className="fa-solid fa-comments mr-2 text-xl" />
          <span className="mr-1 text-xl font-bold">{count}</span>
        </div>
        <span>{pluralize("unread messages", count)}</span>
      </div>
    )
  } else {
    return (
      <div className="flex items-center">
        <i className="fa-solid fa-comments mr-2 text-xl" />
        <span>No new messages</span>
      </div>
    )
  }
}

const Messages = ({ marinaSlug }) => {
  const { isLoading, isError, data } = useQuery(
    ["messages", marinaSlug],
    () => queryMessages(marinaSlug),
    { retry: false, refetchInterval: refreshRate, refetchOnWindowFocus: false }
  )

  return (
    <ReloadableWidget isLoading={isLoading} isError={isError}>
      {data && (
        <TrackingLink
          href={data.messagesLink}
          className="card relative flex w-full items-center justify-between p-6 text-center text-gray-900 no-underline hover:border-blue-800 hover:bg-blue-50 hover:text-blue-700"
          eventName="messages_widget:clicked"
        >
          <DashboardTooltip />
          {renderData(data.messagesCount)}
          <i className="fa-solid fa-chevron-right mt-0.5 text-xs font-semibold" />
        </TrackingLink>
      )}
    </ReloadableWidget>
  )
}

Messages.propTypes = {
  marinaSlug: PropTypes.string.isRequired,
}

export default Messages
